import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Temporal } from '@js-temporal/polyfill';
import { EEventType } from 'src/app/domain/enums/eventType';
import { Event } from 'src/app/domain/event';
import { User } from 'src/app/domain/user';
import { EventService } from 'src/app/services/event.service';
import { NotificationManager } from '../notification-manager';
import { StringConverter } from '../string-converter';
import { UntypedFormControl, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/components/base/base.component';
import { CoreData } from '../../core-data/core-data';

@Component({
    selector: 'custom-event-box',
    templateUrl: 'custom-event-box.html',
    styleUrls: ['./custom-event-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomEventDialog extends BaseComponent implements OnInit {

    public MAX_LENGTH = 40;
    ValidMaxLength = new UntypedFormControl('', [Validators.maxLength(this.MAX_LENGTH)]);
    public EventTypeList: string[] = Object.values(EEventType)
        .filter(x => !isNaN(Number(x)) && x !== 1)
        .map(x => StringConverter.getEventTypeName(x as EEventType));
    public Model: Event = new Event();
    public From: Date = new Date();
    public To: Date = new Date();
    public FromTime: any;
    public ToTime: any;
    public UserList: User[] = [];
    SelectedTechnicianList: User[] = [];
    
    constructor(
        protected override coreData: CoreData,
        private snackbar: MatSnackBar,
        private eventService: EventService,
        public dialogRef: MatDialogRef<CustomEventDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        super(coreData);
        this.UserList = data.users;
        if (data.event) {
            this.Model = Object.assign({}, data.event)
            this.From = this.convertTemporalToDate(data.event.From);
            this.To = this.convertTemporalToDate(data.event.To);
            this.SelectedTechnicianList.push(data.event.Sampler);
            this.setFromTime();
            this.setToTime();
        }
    }

    ngOnInit() {
        this.ValidMaxLength.markAsTouched();
    }

    dateChanged() {
        this.To = this.From;
    }

    fromtimeSet(event: any) {
        const time = event.split(':');

        this.From = new Date(this.From);
        this.From.setHours(Number(time[0]), Number(time[1]));
        this.setFromTime();
    }
    setFromTime() {
        this.FromTime = `${this.From.getHours()}:${this.From.getMinutes()}`;
    }

    totimeSet(event: any) {
        const time = event.split(':');

        this.To = new Date(this.To);
        this.To.setHours(Number(time[0]), Number(time[1]));
        this.setToTime();
    }

    setToTime() {
        this.ToTime = `${this.To.getHours()}:${this.To.getMinutes()}`;
    }

    onCancel() {
        this.dialogRef.close();
    }

    canFinish() {
        return this.ValidMaxLength.valid && this.Model.Sampler && this.FromTime && this.ToTime && this.Model.Titre && this.Model.Type;
    }

    finish() {
        if (!this.canFinish()) {
            return;
        }
        const offset = this.From.getTimezoneOffset();
        console.log(offset)
        this.From.setHours(this.From.getHours() - offset / 60)
        this.To.setHours(this.To.getHours() - offset / 60)
        this.Model.From = Temporal.PlainDateTime.from(this.From.toISOString().substring(0, this.From.toISOString().length - 1));
        this.Model.To = Temporal.PlainDateTime.from(this.To.toISOString().substring(0, this.To.toISOString().length - 1));
        if (this.Model.Code) {
            this.eventService.updateCustomEvent(this.Model).subscribe((x: string) => {
                if (x) {
                    NotificationManager.handleSuccess('Evènement ajouté', this.snackbar);
                    this.dialogRef.close(x);
                }
            })
        } else {
            this.eventService.addCustomEvent(this.Model, this.SelectedTechnicianList.map(x => x.Puid)).subscribe((x: string) => {
                if (x) {
                    NotificationManager.handleSuccess('Evènement ajouté', this.snackbar);
                    this.dialogRef.close(x);
                }
            })
        }
    }

    public compareUserWith(m1: User, m2: User) {
        return m1 && m2 ? m1.Puid === m2.Puid : m1 === m2;
    }
}
